import { Breadcrumb } from "@fluentui/react";
import React, { useContext } from "react";
import themeContext from "../context/theme/ThemeContext";
import { TABS } from "../constants/Constants";

const CustomBreadCrumb = (props) => {
  const { themeName } = useContext(themeContext);
  const extraMargin = (props.headerPagePresent !== undefined && props.headerPagePresent !== null && props.alignmentHeading) ? "12px" : "2px";
  const breadCrumbStyles = {
    root: {
      marginTop: extraMargin
    },
    itemLink: {
      fontSize:'18px',
      color:"#ACACAC"
    },
    item:{
      fontSize:'18px',
      color:"#ACACAC"
    }
  }

  return (
    <div style={{height:'100%',background: themeName === "light"?TABS.LIGHT_GLOBAL_GRAY:"unset"}}>
      <Breadcrumb
        overflowIndex={null}
        items={props.items}
        maxDisplayedItems={10}
        styles={breadCrumbStyles}
      />
    </div>
  );
};

export default CustomBreadCrumb;
